import { render, staticRenderFns } from "./navigationMsg.vue?vue&type=template&id=cf7c0ed8&"
import script from "./navigationMsg.vue?vue&type=script&lang=js&"
export * from "./navigationMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports